import {TicketFields, TicketTypes} from "./Ticket.Constant";

import Joi from 'joi';

export const VALIDATION_TICKER_CREATE = {
  options: {allowUnknownBody: false},
  body: {
    [TicketFields.subjectId]: Joi.string().required(),
    [TicketFields.subjectType]: Joi.string().required(),
    [TicketFields.type]: Joi.string().valid(TicketTypes.CLAIM_CONTRACTOR, TicketTypes.CUSTOMER_SUPPORT).required(),
    [TicketFields.objectId]: Joi.string().required(),
    [TicketFields.objectType]: Joi.string().required(),
    [TicketFields.title]: Joi.string(),
    [TicketFields.content]: Joi.string().required(),
    [TicketFields.attachments]: Joi.array()
  }
};

export const VALIDATION_TICKER_DELETE = {
  options: {allowUnknownBody: false},
  body: {
    [TicketFields.id]: Joi.string().required(),
  }
};

export const VALIDATION_TICKER_UPDATE = {
  options: {allowUnknownBody: false},
  body: {
    [TicketFields.id]: Joi.string().required(),
    [TicketFields.replies]: Joi.array().items(Joi.object().keys({
      message: Joi.string(),
      attachments: Joi.array(),
    })),
    [TicketFields.status]: Joi.string(),
  }
};

export const VALIDATION_TICKER_ADMIN_LIST = {
  options: {allowUnknownBody: false},
  body: {
    [TicketFields.status]: Joi.string(),
    [TicketFields.type]: Joi.string().valid(TicketTypes.CLAIM_CONTRACTOR, TicketTypes.CUSTOMER_SUPPORT),
    page: Joi.number().required(),
  }
};




// WEBPACK FOOTER //
// ./src/services/ticket/Ticket.Validator.js